import React, { useEffect, useState, useRef } from "react";
import logoac from "@/imagenes/lg_publicidad.png";
import Footer from "@/components/Footer";
import { Dimmer } from "@/components/spinner";
import { Mensaje } from "@/components/mensajes2";
import useTableService from "@/components/useTableServerSide";
import { SearchInput } from "@/ui/inputs/Input";
import { AgregarPP } from "./modalRegistrarPP";
import { formatMoneda } from "@/util/varios"; // ajusta la ruta según tu estructura
import moment from "moment";
import axios from "axios";

const MESES = [
  "ENERO",
  "FEBRERO",
  "MARZO",
  "ABRIL",
  "MAYO",
  "JUNIO",
  "JULIO",
  "AGOSTO",
  "SEPTIEMBRE",
  "OCTUBRE",
  "NOVIEMBRE",
  "DICIEMBRE",
];

export default function TablaPP() {
  const op = require("../../../../src/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const searchTimeoutRef = useRef(null);
  const [searchInput, setSearchInput] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
  });
  const [totales, setTotales] = useState({
    total: 0,
    activos: 0,
    inactivos: 0,
  });

  // ===== Estados para el modal AgregarPP (migrados) =====
  const [mostrar5, setMostrar5] = useState(false);
  const [comercio, setComercio] = useState();
  const [persona, setPersona] = useState();
  const [detalle, setDetalle] = useState();
  const [deuda, setDeuda] = useState();
  const [history, setHistory] = useState();
  const [total, setTotal] = useState(0.0);
  const [valorut, setValorut] = useState();
  const [operacion, setOperacion] = useState(0);
  const [espiritu] = useState(localStorage.getItem("espiritu"));
  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const factorCambio = JSON.parse(localStorage.getItem("factorCambio"));

  const cardsData = [
    {
      title: "Propagandas y Publicidades Registrados",
      value: totales.total || 0,
      color: "#053160",
      icon: "fas fa-cash-register fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
    },
    {
      title: "Propagandas y Publicidades Activos",
      value: totales.activos || 0,
      color: "#76b8e8",
      icon: "fas fa-toggle-on fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
    },
    {
      title: "Propagandas y Publicidades Inactivos",
      value: totales.inactivos || 0,
      color: "#ca4117",
      icon: "fas fa-toggle-off fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
    },
  ];

  const headCells = [
    {
      id: "idcomercio",
      label: "CODIGO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "ritm",
      label: "RITM",
      width: "40px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "rif",
      label: "RIF",
      width: "40px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "nombre",
      label: "NOMBRE",
      width: "300px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "direccion",
      label: "DIRECCIÓN",
      width: "200px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "accion",
      label: "OPCIONES",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
  };

  const { TblContainer, TblHead, TblPagination } = useTableService(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (value.length === 0)
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    if (value.length < 3) return;
    searchTimeoutRef.current = setTimeout(
      () => setTableState((prev) => ({ ...prev, search: value, page: 0 })),
      500,
    );
  };

  const buscarPublicdad = () => {
    setLoading(true);
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
    };
    const endpoint = `${op.conexion}/api/publicidad/gestion-contribuyentes`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
          setTotales(response.data.totales);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));
  };


  const blanquear = () => {
    setLoading(false);
    setComercio();
    setPersona();
    setDetalle();
    setDeuda();
    setHistory();
    setTotal(0.0);
  };

  const seleccionarRegistro = (idcomercio) => {
    const campos = "*";
    const nomtab = "comercio";
    const nomid = "idcomercio";
    const endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idcomercio}&nomtab=${nomtab}&nomid=${nomid}`;
    setLoading(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.idcomercio > 0) {
          setComercio(response.data);
          seleccionarRegistroPersona(response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message || "Error al consultar el registro",
          icono: "error",
        });
        setLoading(false);
      });
  };

  const seleccionarRegistroPersona = (data) => {
    const campos = "*";
    const nomtab = "persona";
    const nomid = "cedula";
    const endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.reprelegal}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.cedula > 0) {
          setPersona(response.data);
        }
        seleccionarDeuda(data);
        setLoading(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message || "Error al consultar la persona",
          icono: "error",
        });
        setLoading(false);
      });
  };

  const seleccionarDeuda = (data) => {
    const nomtab = "publicidad";
    const idcom = "idcomercio";
    const endpoint = `${op.conexion}/api/publicidad/consultadeuda?nomtab=${nomtab}&nomid=${idcom}&id=${data.idcomercio}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            const respuesta = [];
            const historyArr = [];
            let desc = 0.0;

            response.data.forEach((item) => {
              const mm =
                item.fechainscripcion === null
                  ? 0
                  : parseInt(
                      moment
                        .utc(item.fechainscripcion)
                        .format("YYYY-MM-DD")
                        .substring(5, 7),
                    );
              const mes = MESES[mm - 1] || "";

              const registro = {
                idpublicidad: item.idpublicidad,
                idcomercio: item.idcomercio,
                idtipopublicidad: item.idtipopublicidad,
                ancho: item.ancho,
                alto: item.alto,
                cantidad: item.cantidad,
                monto: item.monto,
                anio: item.anio,
                cancelada: item.cancelada,
                fechainscripcion: item.fechainscripcion,
                ubicacion: item.ubicacion,
                fechapago: item.fechapago,
                numerorecibo: item.numerorecibo,
                reccroquisubi: item.reccroquisubi,
                recplanoestructura: item.recplanoestructura,
                recautpropieinmue: item.recautpropieinmue,
                recautinsvialreg: item.recautinsvialreg,
                recusoconfddu: item.recusoconfddu,
                descripcion: item.descripcion,
                codigoordenanza: item.codigoordenanza,
                mes: mes,
              };

              if (!item.cancelada) {
                desc += parseFloat(item.monto);
                respuesta.push(registro);
              } else {
                historyArr.push(registro);
              }
            });

            setDeuda(respuesta);
            setHistory(historyArr);
            setTotal(
              formatMoneda(desc.toString().replace(".", ","), ",", ".", 2),
            );
          }
          setMostrar5(true);
        }
        setLoading(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response?.data?.message || "Error al consultar la deuda",
          icono: "error",
        });
        setLoading(false);
      });
  };

  const seleccionarConfiguracion = () => {
    const campos = "*";
    const nomtab = "configindustria";
    const orden = "1";
    const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (
          response.status === 200 &&
          response.data[0]?.factorcalculo != null
        ) {
          SelectValorUT(response.data[0].factorcalculo);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al obtener la configuración",
          icono: "error",
        });
      });
  };

  const SelectValorUT = (factorcalculo) => {
    const m = parseInt(fechaSistema?.substring(6, 8));
    const a = parseInt(fechaSistema?.substring(1, 5));
    const endpoint = `${op.conexion}/api/publicidad/valorut?factorcalculo=${factorcalculo}&anio=${a}&mes=${m}&espiritu=${espiritu}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          setValorut(response.data[0].valor);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al obtener el valor de la UT",
          icono: "error",
        });
      });
  };

  const consultarPP = (ope, id) => (event) => {
    event.preventDefault();
    blanquear();
    if (ope === 1) {
      setMostrar5(true);
      setOperacion(1);
    } else if (ope === 4) {
      setOperacion(4);
      seleccionarRegistro(id);
    } else if (ope === 2) {
      setOperacion(2);
      seleccionarRegistro(id);
    } else if (ope === 3) {
      setOperacion(3);
      seleccionarRegistro(id);
    }
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };


  useEffect(() => {
    seleccionarConfiguracion();
  }, []);

  useEffect(() => {
    buscarPublicdad();
  }, [tableState]);

  return (
    <div
      className="container-fluid p-4"
      style={{ backgroundColor: "#f8f9fa", height: "90vh", marginTop: "-4%" }}
    >
      <div className="row g-4 mb-4">
        {cardsData.map((card, index) => (
          <div
            key={index}
            style={{ borderRadius: 4 }}
            className="col-12 col-sm-6 col-xl"
          >
            <div
              className="card h-100 border-0 rounded-4 shadow-sm position-relative overflow-hidden"
              style={{
                background: card.color,
                color: "white",
                transition: "transform 0.3s, box-shadow 0.3s",
                borderRadius: 15,
                cursor: "pointer",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: -20,
                  right: -20,
                  width: 100,
                  height: 100,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: -30,
                  left: -30,
                  width: 150,
                  height: 150,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.05)",
                }}
              ></div>

              <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <span
                      className="text-uppercase small fw-bold opacity-75"
                      style={{ letterSpacing: "2px", fontSize: "1rem" }}
                    >
                      {card.title}
                    </span>
                    <h2
                      className="fw-bold mb-0 mt-1"
                      style={{ fontSize: "2.2rem" }}
                    >
                      {card.value}
                    </h2>
                  </div>
                  <i
                    className={card.icon}
                    style={{ color: card.iconColor }}
                  ></i>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="row g-4">
        <div className="col-8">
          <div
            className="card shadow-sm border-0"
            style={{ borderRadius: "15px" }}
          >
            <div className="card-header azulGradiant text-white">
              <h5 className="mb-0 fw-bold">
                Gestion de Registro de Propaganda y Publicidad
              </h5>
            </div>
            <div className="card-body p-0 m-0">
              <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between align-items-start">
                <div className="col-4 m-0 p-0 position-relative">
                  <SearchInput
                    className="search-input pe-4"
                    value={searchInput}
                    onChange={handleSearch}
                  />
                </div>
              </div>
              <section className="col-12 m-0 p-0">
                <TblContainer>
                  <TblHead />
                  <tbody>
                    {records &&
                      records.map((item) => (
                        <tr
                          key={item.idcomercio}
                          style={{ padding: "0", cursor: "pointer" }}
                        >
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "10px",
                            }}
                          >
                            {item.idcomercio}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "40px",
                            }}
                          >
                            {item.ritm}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "40px",
                            }}
                          >
                            {item.rif}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "left",
                              width: "auto",
                            }}
                          >
                            {item.nombre}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "left",
                              width: "auto",
                            }}
                          >
                            {item.direccion}
                          </td>
                          <td
                            className="py-1"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "180px",
                              padding: 0,
                            }}
                          >
                            <button
                              onClick={consultarPP(2, item.idcomercio)}
                              className="btn btn-sm btn-info rounded-circle"
                            >
                              <i className="fas fa-eye"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
                <TblPagination />
              </section>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div
            className="card shadow-1-strong d-flex align-items-center justify-content-center"
            style={{ borderRadius: "15px", minHeight: "500px" }}
          >
            <div className="text-center p-4">
              <img
                src={logoac}
                alt="Dashboard Illustration"
                className="img-fluid"
                style={{
                  maxHeight: "500px",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <AgregarPP
        show={mostrar5}
        comercio={comercio}
        factorCambio={factorCambio?.valor}
        persona={persona}
        detalle={detalle}
        deuda={deuda}
        valorpetro={valorut}
        history={history}
        total={total}
        onHideRenderizar={seleccionarRegistro}
        onHideCancela={cerrarModalActualizar}
        operacion={operacion}
      />
      <Dimmer active={loading} inverted />
      <Footer />
    </div>
  );
}
